import React from "react";
import { useTranslation } from "react-i18next";
import { makeStyles } from "@material-ui/styles";
import { Typography } from "@material-ui/core";
import Footer from "../Location/components/Footer";

const useStyles = makeStyles((theme) => ({
  wrapper: {
    display: "flex",
    flexDirection: "column",
    flex: 1,
    padding: "20px",
    backgroundColor: "#fff",
    // alignItems: 'center',
    minHeight: "calc(100vh - 150px)",
    [theme.breakpoints.down("xs")]: {
      minHeight: "calc(100vh - 110px)",
    },
  },
  title: {
    fontSize: "20px",
    fontWeight: "bold",
    lineHeight: "32px",
    // margin: '25px 0'
    whiteSpace: "pre-wrap",
  },
  bodyText: {
    fontWeight: 500,
    fontSize: "18px",
    lineHeight: "131%",
    margin: "20px 0",
    maxWidth: "100%",
    wordBreak: "break-word",
    whiteSpace: "pre-wrap",
  },
  link: {
    color: "#878787",
    fontSize: "18px",
    margin: "0 5px",
    wordBreak: "break-word",
    whiteSpace: "pre-wrap",
  },
}));

const Terms = () => {
  const classes = useStyles();
  const { t } = useTranslation();
  const arr = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16];

  return (
    <div className={classes.wrapper}>
      {arr.map((item) => (
        <React.Fragment key={item}>
          <Typography color="textPrimary" className={classes.title}>
            {t(`terms:title${item}`)}
          </Typography>
          <Typography color="textPrimary" className={classes.bodyText}>
            {t(`terms:text${item}`)}
          </Typography>
        </React.Fragment>
      ))}
      <Typography color="textPrimary" className={classes.title}>
        {t(`terms:title17`)}
      </Typography>
      <Typography color="textPrimary" className={classes.bodyText}>
        {t(`terms:text17`)}
        <a
          href={`${t("terms:link17")}`}
          className={classes.link}
          target="_blank"
          rel="noreferrer"
        >
          {t(`terms:link17`)}
        </a>
        {t(`terms:text17_1`)}
      </Typography>
      <Footer />
    </div>
  );
};

export default Terms;
